module.exports = __webpack_public_path__ + "img/AdelleSansSAGE.f4b3b1c5.svg";